/**
 * Created by Ning Jiang on 10/16/2018.
 */

import {NoWinSymbolsWinPresentationController} from "@nolimitcity/slot-game/bin/game/winpresentation/nowinsymbols/NoWinSymbolsWinPresentationController";
import {TombstoneParsedGameData} from "../../server/data/TombstoneParsedGameData";

export class TombstonNoWinPresentationController extends NoWinSymbolsWinPresentationController {

    private _tombstoneData:TombstoneParsedGameData;

    constructor(indexes:[number, number]) {
        super(indexes, {noWinStateFadeInDuration : 1});
    }

    protected parseFeatureGameData(data:TombstoneParsedGameData):void {
        this._tombstoneData = data;
        super.parseFeatureGameData(data);

        if(this._tombstoneData.bonusTriggeredThisSpin || this._tombstoneData.superFreespinTriggeredThisSpin) {
            this._symbolWinStates[0][this._tombstoneData.bonusPositions[0]] = true;
            this._symbolWinStates[4][this._tombstoneData.bonusPositions[4]] = true;
        }

        if(this._tombstoneData.freespinTriggeredThisSpin || this._tombstoneData.superFreespinTriggeredThisSpin) {
            this._symbolWinStates[1][this._tombstoneData.scatterPositions![1]] = true;
            this._symbolWinStates[2][this._tombstoneData.scatterPositions![2]] = true;
            this._symbolWinStates[3][this._tombstoneData.scatterPositions![3]] = true;
        }
    }

    // Add the respin and freespins, so it can handle the no win symbols even when there is no win.
    protected hasWin():boolean {
        return super.hasWin() || this._tombstoneData.bonusTriggeredThisSpin || this._tombstoneData.freespinTriggeredThisSpin || this._tombstoneData.superFreespinTriggeredThisSpin;
    }
}
